import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PathInterceptorService implements HttpInterceptor {

  constructor() { }

  public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const isAbsolute = /^https?:\/\//i.test(request.url);

    const url = isAbsolute
      ? request.url
      : environment.apiUrl + request.url;

    const apiReq = request.clone({ url });

    return next.handle(apiReq);
  }
}
